import Imgix from 'react-imgix';
import React from 'react';
import { useAppSelector } from '../dal/store';

const Description = () => {
    const userWidget = useAppSelector(store => store.root.userWidget);

    return (
        <>
            <p className="waves-h3">{ userWidget?.widgetTitle }</p>
            <p className="mb-4" dangerouslySetInnerHTML={{ __html: userWidget?.widgetIntro || '' }} />
            <div className="mb-6 flex flex-col justify-center max-w-full mx-auto border rounded overflow-hidden text-left" style={{
                width: '500px',
            }}>
                <Imgix
                    src={ 'https://media.wavescdn.com/images/misc/rfr/red-share.jpg' }
                    height={ 250 }
                    className="max-w-full"
                    htmlAttributes={{
                        loading: 'lazy',
                    }}
                />
                <p className="px-4 pt-4 text-lg">{ userWidget?.friendTitle }</p>
                <p className="px-4 pb-4 pt-2 text-sm" dangerouslySetInnerHTML={{ __html: userWidget?.friendIntro || '' }} />
            </div>
        </>
    )
};

export default Description;